import { schema } from 'normalizr';
import apiResourceBuilder from '../../../../common/utils/apiResourceBuilder';
import entityActionCreator from '../../../../common/utils/entityActionCreator';

export const surveyResponsesApi = apiResourceBuilder('emts/surveyresponse');

export const surveyResponseSchema = new schema.Entity(
  'surveyResponses',
  {},
  { idAttribute: 'key' }
);

export default entityActionCreator({
  schema: surveyResponseSchema,
  api: surveyResponsesApi,
});



// WEBPACK FOOTER //
// ./src/App/account/actions/surveys/surveyResponses.js